import { AxiosInstance } from 'axios';
import {
  CheckEmailResponse,
  LoginCredentials,
  MagicLinkRequest,
  MeResponse,
  MessageResponse,
  ResetPasswordRequest,
  SignUpCredentials,
  TokenResponse,
} from '@/api/auth/auth.types.ts';

export const createAuthApi = (api: AxiosInstance) => ({
  signIn: (credentials: LoginCredentials) =>
    api.post<TokenResponse>('/v1/auth/sign-in', credentials),

  checkEmail: (email: string) =>
    api.post<CheckEmailResponse>('/v1/auth/check-email', { email }),

  signUp: (credentials: SignUpCredentials) =>
    api.post<TokenResponse>('/v1/auth/sign-up', credentials),

  me: () => api.get<MeResponse>('/v1/auth/me'),

  forgotPassword: (email: string) =>
    api.post<MessageResponse>('/v1/auth/forgot-password', { email }),

  resetPassword: (payload: ResetPasswordRequest) =>
    api.post<MessageResponse>('/v1/auth/reset-password', payload),

  requestMagicLink: (email: string) =>
    api.post<MessageResponse>('/v1/auth/request-magic-link', { email }),

  consumeMagicLink: (payload: MagicLinkRequest) =>
    api.post<TokenResponse>('/v1/auth/magic-link', payload),
});
